import React from "react";
import "./Home.scss";
import shoppingimage from "./shoppingimage.jpg";
import Product from "./Product/Product";
import powerbank from "./Product/powerbank.jpg";
import Mouse from "./Product/Mouse.jpg";
import Keyboard from "./Product/Keyboard.jpg";
import Trimmer from "./Product/Trimmer.jpg";
import Mobile from "./Product/Mobile.jpg";
import CleaningKit from "./Product/CleaningKit.jpg";
import lamp from "./Product/lamp.jpg";

function Home() {
  return (
    <div className="home">
      <div className="home_container">
        <img className="ShoppingImage" src={shoppingimage} alt="" />
      </div>

      <div className="body_row">
        <Product
          id="11"
          title="Power Bank"
          price={1400}
          image={powerbank}
          rating={3}
        />
        <Product
          id="12"
          title="Mouse"
          price={399}
          image={Mouse}
          rating={4}
        />
      </div>

      <div className="body_row">
        <Product
          id="13"
          title="Keyboard"
          price={700}
          image={Keyboard}
          rating={1}
        />
        <Product
          id="14"
          title="Trimmer"
          price={1500}
          image={Trimmer}
          rating={5}
        />
        <Product
          id="15"
          title="CleaningKit"
          price={299}
          image={CleaningKit}
          rating={5}
        />
      </div>

      <div className="body_row">
        <Product
          id="16"
          title="lamp"
          price={3000}
          image={lamp}
          rating={3}
        />
      </div>
    </div>
  );
}

export default Home;
